/* eslint-disable @typescript-eslint/explicit-function-return-type */

const SESSION_STORAGE_TRIGGER_REVIEW_FORM = 'show_review_form'

/**
 * Use session storage to determine if the review form should be opened on user being redirected after login.
 */
export const checkShouldTriggerReviewForm = (): boolean => {
  return sessionStorage.getItem(SESSION_STORAGE_TRIGGER_REVIEW_FORM) === 'true'
}

export const setShouldTriggerReviewForm = (shouldShow: boolean): void => {
  if (shouldShow) {
    sessionStorage.setItem(SESSION_STORAGE_TRIGGER_REVIEW_FORM, 'true')
    return
  }
  sessionStorage.removeItem(SESSION_STORAGE_TRIGGER_REVIEW_FORM)
}
